import { useAppSelector } from '@application/store/useStore';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
export default function OrderTabsHelpers() {
    const { unchangedOrder } = useAppSelector((state) => state.order);
    const [infoTabErrorBorderColor, setInfoTabErrorBorderColor] = useState(false);
    const [isInfoTabBold, setIsInfoTabBold] = useState(false);
    const [isNotesTabBold, setIsNotesTabBold] = useState(false);
    const [formData, setFormData] = useState({
        id: 0,
        orderNumber: '',
        supplierId: 0,
        contactPerson: '',
        contactPersonId: 0,
        // workorderId: 0,
        workorderId: null,
        deliveryDate: new Date(),
        deliveryDateOnOrder: false,
        externalNote: '',
        statusId: 1,
        requestDate: null,
        orderDate: null,
        note: '',
        // debtorId: 0,
        debtorId: null,
        debtorName: '',
        isWorkOrderLinked: false
    });
    const [errors, setErrors] = useState({
        orderNumber: '',
        supplierId: '',
        contactPersonId: '',
        workorderId: '',
        deliveryDate: '',
        debtorId: '',
        debtorName: '',
        deliveryAddress: '',
    });
    useEffect(() => {
        if (!errors.orderNumber && !errors.deliveryDate && !errors.supplierId && !errors.contactPersonId && !errors.deliveryAddress) {
            setInfoTabErrorBorderColor(false);
        }
    }, [errors]);
    const handleFieldChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: ''
        }));
    };
    const handleToggelButtonChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
    };
    const handleCalendarChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [fieldName]: ''
        }));
    };
    useEffect(() => {
        checkBoldFieldsOrder();
        checkUnchangedFieldsOrder();
    }, [formData, unchangedOrder]);
    const validateForm = () => {
        const newErrors = {
            orderNumber: '',
            supplierId: '',
            contactPersonId: '',
            workorderId: '',
            deliveryDate: '',
            debtorId: '',
            debtorName: '',
            deliveryAddress: '',
        };
        if (formData.orderNumber.replaceAll('@', '').trim() == '') {
            newErrors.orderNumber = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        // if (formData.workorderId <= 0) {
        //     newErrors.workorderId = 'Dit veld is verplicht';
        // }
        // if (formData.debtorId <= 0 || formData.debtorName?.trim() == "") {
        //     newErrors.debtorId = 'Dit veld is verplicht';
        // }
        if (!formData.deliveryDate) {
            newErrors.deliveryDate = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (formData.supplierId <= 0) {
            newErrors.supplierId = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        if (formData.contactPerson && formData.contactPerson?.length > 30) {
            newErrors.contactPersonId = 'Contactpersoon mag niet langer zijn dan 30 tekens';
            setInfoTabErrorBorderColor(true);
        }
        if (!formData.deliveryAddress || formData.deliveryAddress == '') {
            newErrors.deliveryAddress = 'Dit veld is verplicht';
            setInfoTabErrorBorderColor(true);
        }
        setErrors(newErrors);
        return newErrors;
    };
    //---------------------Unsaved Functionality----------------------------
    const [isInfoTabUnsaved, setInfoTabUnsaved] = useState(false);
    const [isNotesTabUnsaved, setNotesTabUnsaved] = useState(false);
    const { id } = useParams();
    const checkUnchangedFieldsOrder = () => {
        if (unchangedOrder && formData && id) {
            let isInfoTabUnsaved = false;
            let isNotesTabUnsaved = false;
            // Check for unsaved changes in the Info tab
            if (unchangedOrder.orderNumber != formData.orderNumber ||
                unchangedOrder.deliveryDate != formData.deliveryDate ||
                unchangedOrder.supplierId != formData.supplierId ||
                unchangedOrder.contactPersonId != formData.contactPersonId ||
                unchangedOrder.referenceContactPersonId != formData.referenceContactPersonId ||
                unchangedOrder.deliveryDateOnOrder != formData.deliveryDateOnOrder ||
                unchangedOrder.externalNote != formData.externalNote ||
                unchangedOrder.requestDate != formData.requestDate ||
                unchangedOrder.orderDate != formData.orderDate ||
                unchangedOrder.deliveryAddress != formData.deliveryAddress) {
                isInfoTabUnsaved = true;
            }
            // Check for unsaved changes in the Notes
            if (formData.note !== unchangedOrder.note) {
                isNotesTabUnsaved = true;
            }
            // Set unsaved state for all tabs
            setInfoTabUnsaved(isInfoTabUnsaved);
            setNotesTabUnsaved(isNotesTabUnsaved);
        }
    };
    const checkBoldFieldsOrder = () => {
        if (formData.orderNumber ||
            formData.referenceContactPersonId ||
            formData.supplierId ||
            formData.contactPersonId ||
            formData.deliveryDate ||
            formData.externalNote ||
            formData.deliveryDateOnOrder == true ||
            formData.requestDate ||
            formData.orderDate ||
            formData.deliveryAddress) {
            setIsInfoTabBold(true);
        }
        if (formData.note) {
            setIsNotesTabBold(true);
        }
        else {
            setIsNotesTabBold(false);
        }
    };
    return {
        handleFieldChange,
        handleToggelButtonChange,
        handleCalendarChange,
        validateForm,
        formData,
        setFormData,
        errors,
        infoTabErrorBorderColor,
        isInfoTabUnsaved,
        isNotesTabUnsaved,
        isInfoTabBold,
        isNotesTabBold
    };
}
